import { GPUArrayBuffer } from './GPUBuffer'
import { GPUProgram } from './GPUProgram'
import { Interact } from './Interact'
import { shaderLib, shaderLibHeader } from './ShaderLib'
import * as GL from './webgl2constants'

let defaultUniforms = `
uniform float time;
uniform float viewzoom;
uniform vec3 viewpos;
uniform mat3 viewrot;
uniform vec2 res;
uniform float aspect;
${Interact.keyList.map(k => `uniform vec2 slider_${k};`).join('')/* all sliders */}
${Interact.keyList.map(k => `uniform mat3 rot_${k};`).join('')/* all rotations */}
`

export class DPCGProgram extends GPUProgram {
	interact: Interact

	constructor(gl: WebGL2RenderingContext, vsrc: string, fsrc: string) {
		super(gl,
			`${defaultUniforms}\n${shaderLibHeader()}\n${vsrc}\n${shaderLib()}`,
			`${defaultUniforms}\n${shaderLibHeader()}\n${fsrc}\n${shaderLib()}`
		)
		this.interact = new Interact() // TODO set interact HTML element
// 	document.getElementById("lgCanvas").resize()
// 	gl.viewport(0, 0, gl.canvas.width, gl.canvas.height)
	}

	setDefaultUniforms() {
		// TODO set uniforms
		let [x, y, w, h] = this.gl.getParameter(GL.VIEWPORT)

		this.setUniform("time", time)
		this.setUniform("viewzoom", Math.exp(this.interact.viewZ))
		this.setUniform("viewpos", this.interact.viewP)
		this.setUniform("viewrot", this.interact.viewR)
		this.setUniform("res", [w,h])
		this.setUniform("aspect", w/h)

		// this.setUniform( "NaN", [NaN]) // TODO : as float
		// this.setUniform("iNaN", [NaN]) // TODO : as int

		Interact.keyList.map(k => this.setUniform(`slider_${k}`, (this.interact as any).sliders[k]) )
		Interact.keyList.map(k => this.setUniform(`rot_${k}`, (this.interact as any).rots[k]) )
	}

	drawArrays(mode: GLenum, count: GLsizei, first: GLint = 0) {
		this.setDefaultUniforms()
		super.drawArrays(mode, count, first)
	}

	drawElements(mode: GLenum, count: GLsizei, offset: GLintptr = 0) {
		this.setDefaultUniforms()
		super.drawElements(mode, count, offset)
	}

}

export class DPCGProgram2d extends DPCGProgram {

	constructor(gl: WebGL2RenderingContext, fsrc: string) {
		super(gl,
			`in vec2 pos;out vec2 uv; void main() { gl_Position = vec4(pos,0,1); uv = pos; }`, // uv = pos*.5 + vec2(.5); }
			`in vec2 uv;${fsrc}`
		)
		let quad = new GPUArrayBuffer(gl)
		quad.gpumem = [-1, -1, -1, +1, +1, -1, +1, +1]
		this.attribs["pos"].gpumem = quad
	}

	draw() { this.drawArraysTriangleStrip(4) }

}
